import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

type ChartWithHeaderContainerProps = {
	header: JSX.Element;
	chart: JSX.Element;
};

export const ChartWithHeaderContainer = ({ header, chart }: ChartWithHeaderContainerProps) => {
	return (
		<Box xcss={containerStyles}>
			<Box>{header}</Box>
			{chart}
		</Box>
	);
};

const containerStyles = xcss({
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.200',
});
